<div class="layout-container" [ngClass]="containerClass">
  <app-sidebar></app-sidebar>
  <div class="layout-content-wrapper" style="position: relative">
    <app-topbar></app-topbar>
    <app-breadcrumb class="content-breadcrumb"></app-breadcrumb>
    <div class="layout-content" [ngClass]="{ 'subscription-background': shouldShowSubscriptionBackground }" style="position: relative">
      <!-- Show router-outlet when subscription is valid, still loading, or company owner is on subscription page -->
      <router-outlet *ngIf="shouldShowRouterOutlet"></router-outlet>

      <!-- Show glass effect instead of router-outlet when subscription is invalid (unless company owner is on subscription page) -->
      <oms-glass-background
        *ngIf="shouldShowGlassOverlay"
        class="subscription-overlay"
        [paddingTop]="56"
        [paddingBottom]="32"
        [paddingX]="32"
        [borderRadius]="12"
        [backgroundOpacity]="0.48"
      >
        <div class="text-center" style="display: flex; flex-direction: column; align-items: center; gap: 16px">
          <p-avatar
            icon="pi pi-lock"
            size="xlarge"
            shape="circle"
            [style]="{ backgroundColor: '#6E67ED', color: 'white', width: '64px', height: '64px' }"
          >
          </p-avatar>
          <h2 style="font-size: 20px; font-weight: 500; color: #212121; margin: 0">Αναβάθμιση Συνδρομής</h2>
          <p style="font-size: 14px; color: #b0b0b0; margin: 0">Αναβαθμίστε σε Premium για πρόσβαση σε όλες τις λειτουργίες</p>
          <p-button label="Αναβάθμιση σε Premium" icon="pi pi-bolt" styleClass="p-button-primary" (onClick)="onUpgradeClick()"> </p-button>
        </div>
      </oms-glass-background>
    </div>
  </div>
  <app-profilemenu (sidebarClosed)="layoutService.hideProfileSidebar()"></app-profilemenu>
  <div class="layout-mask"></div>
</div>
